import { InventoryStatus, ReserveStatus } from '../../types';

interface Props {
  inventoryStatus: InventoryStatus;
  reserveStatus: ReserveStatus;
}
const getPhoneInventoryStatus = ({ inventoryStatus, reserveStatus }: Props) => {
  switch (reserveStatus) {
    case ReserveStatus.Always:
      return InventoryStatus.ShipToStore;
    default:
      return inventoryStatus;
  }
};

export default getPhoneInventoryStatus;
